import { ModelBase } from 'store/model-base';

export class CmsHop extends ModelBase {
    public static storeName: string = 'cmsHop';

    public timeout: string;
    public success: string[];
    public errors: CmsHopError;
}
